var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "message-delay-slider",
      class: { active: _vm.active && !_vm.previewMode },
      attrs: { autofocus: true },
      on: {
        click: function ($event) {
          _vm.active = true
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "delay" },
        [
          _c(
            "span",
            {
              staticClass: "material-icons",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return function (e) {
                    e.stopPropagation()
                    _vm.active = false
                  }.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n            timer\n        ")]
          ),
          _vm._v(" "),
          !_vm.active
            ? _c("div", { staticClass: "delay-current" }, [
                _vm._v(
                  "+" +
                    _vm._s(_vm.mirrorValue) +
                    "s " +
                    _vm._s(_vm.$t("chatbotv2.delay"))
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.active && !_vm.previewMode
            ? _c(
                "div",
                {
                  staticClass: "delay-range",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return function (e) {
                        e.stopPropagation()
                        _vm.active = false
                      }.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            +" + _vm._s(_vm.mirrorValue) + "s\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.active && !_vm.previewMode
            ? _c("vue-slider", {
                ref: "slider",
                attrs: {
                  width: "100%",
                  min: 0,
                  max: 10,
                  interval: 0.1,
                  tooltipPlacement: "bottom",
                  dotSize: 0,
                },
                model: {
                  value: _vm.mirrorValue,
                  callback: function ($$v) {
                    _vm.mirrorValue = $$v
                  },
                  expression: "mirrorValue",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.active && !_vm.previewMode
            ? _c("div", { staticClass: "delay-range" }, [_vm._v("+10s")])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }